/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useEffect, useState } from 'react';
import { Grid, Card, Button } from '@scuf/common';
import './NILMRegistrationTheme.scss';
import descriptors from '../../locales/en-US/descriptors';
import { useTranslation } from '@scuf/localization';
// import NILMModal from './NILMOnboardPopup';
import { ContextProvider, updateApiConfig } from '../../context/ApiContext';
import { DataContextProvider } from '@forge/data-connector';
import { NILMRegistrationProps } from './NILMTypes';
import { withLocalization } from '../../locales/withLocalization';

const NILMRegistration = (props: NILMRegistrationProps) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const {
    connectorConfig,
    bearerToken,
    requestContext,
    emaasContext,
    isNILMRegisteredSite,
    setViewDetails,
    goToDashboard
  } = props;

  const d = descriptors.NILM;
  const e = descriptors.energyManagement;
  const [t] = useTranslation();

  useEffect(() => {
    if (props.addMeter) {
      setShowModal(true);
    }
  }, [props.addMeter]);

  return (
    <div className="NILM-Registration">
      <Card>
        <Card.Header>
          <div>{t(d.NILMcardheader)}</div>
        </Card.Header>

        <Card.Content>{t(d.NILMcardsubheader)}</Card.Content>
        {!isNILMRegisteredSite ? (
          <Button
            className="NILM-Register-Button"
            onClick={() => {
              setShowModal(true);
            }}
            type="inline-secondary"
            size="small"
            content="Register"
          />
        ) : (
          <div>
            <Button
              className="NILM-View-Details-Button"
              onClick={() => {
                setViewDetails();
              }}
              type="inline-secondary"
              size="small"
              content={t(e.VIEWDETAILS)}
            />
            <span className="NILM-Dashboard-Navigation" onClick={goToDashboard}>
              Go to Dashboard
            </span>
          </div>
        )}
        {showModal && (
          <ContextProvider
            value={updateApiConfig({
              connectorConfig,
              ...emaasContext
            })}
          >
            <DataContextProvider config={connectorConfig}>
              <div />
              {/* <NILMModal
                bearerToken={bearerToken}
                requestContext={requestContext}
                openNILM={showModal}
                closeNILMModal={() => {
                  setShowModal(false);
                }}
              /> */}
            </DataContextProvider>
          </ContextProvider>
        )}
      </Card>
    </div>
  );
};

export default withLocalization<NILMRegistrationProps>(NILMRegistration);
